import React, { useState, useContext } from "react";
import { renderStatementWithKaTeX } from "../../../../../Status";
import { AuthContext } from "../../../../../context/authContext";
import API from "../../../../../Functions/API/api";
import "./AddDailyProbelmForm.css";

const AddDailyProbelmForm = ({ chosenDate }) => {
  const [problemStatement, setProblemStatement] = useState("");
  const [ProblemField, setProblemField] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [source, setSource] = useState("");
  const [hints, setHints] = useState([]);
  const [hintInput, setHintInput] = useState("");

  const { user } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!chosenDate) return alert("Please select a date first!");

    try {
      const payload = {
        field: ProblemField,
        difficulty,
        statement: problemStatement,
        source,
        author: { _id: user?._id, name: user?.username },
        type: "Daily",
        status: "Upcoming",
        tags: [],
        solution: "",
        hints,
        votes: [] // ensure votes array exists for new suggestions
      };

      const res = await API.post(
        `/DailyProblemSuggestion/`,
        { date: chosenDate, problemData: payload }
      );

      console.log("Problem added:", res.data);
      alert("✅ Problem added successfully!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "❌ Failed to add problem");
    }
  };

  return (
    <div className="AddProblem-container">
      <h2 className="AddProblem-heading" style={{ color: "#9a0002" }}>
        🔍 Suggest a Daily Problem
      </h2>

      <form className="AddProblem-content" onSubmit={handleSubmit}>
        <div className="AddProblem-tags">
          <h2>- Field :</h2>
          <select
            value={ProblemField}
            onChange={(e) => setProblemField(e.target.value)}
            className="AddProblem-difficulty"
            required
          >
            <option value="" disabled>Select Field</option>
            <option value="Algebra">Algebra</option>
            <option value="Geometry">Geometry</option>
            <option value="NumberTheory">Number Theory</option>
            <option value="Combinatorics">Combinatorics</option>
          </select>

          <h2>- Difficulty :</h2>
          <select
            value={difficulty}
            onChange={(e) => setDifficulty(e.target.value)}
            className={`AddProblem-difficulty ${difficulty}`}
            required
          >
            <option value="" disabled>Select difficulty</option>
            <option value="Easy">Easy</option>
            <option value="Medium">Medium</option>
            <option value="Hard">Hard</option>
          </select>

          <h2>- Source :</h2>
          <div className="tags-row">
            <input
              value={source}
              className="tag-input"
              type="text"
              placeholder="Include source ..."
              onChange={(e) => setSource(e.target.value)}
              required
            />
          </div>
        </div>

        <label className="section-label">Problem Statement :</label>
        <div className="AddProblem-title">
          {renderStatementWithKaTeX(problemStatement)}
        </div>
        <textarea
          className="ProblemStatementFillUp"
          value={problemStatement}
          onChange={(e) => setProblemStatement(e.target.value)}
          required
        />

        <div className="AddProblem-buttons-conatiner">
          <button className="AddProblem-button-SC" type="submit">
            Add Problem
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDailyProbelmForm;
